import './bulk-messages-slot-list.scss';

import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { BulkSlotItemDataFragment } from '../../../../data/types/api/graphql';
import { CustomFormattedMessage } from '../../../../elements/intl/custom-formatted-message';
import { BulkMessagesSlotListItem } from './bulk-messages-slot-list-item';

type BulkMessagesSlotListProps = {
  loading?: boolean;
  items: BulkSlotItemDataFragment[];
  onClick?: (value: BulkSlotItemDataFragment) => void;
  onDelete?: (value: BulkSlotItemDataFragment) => void;
};

function BulkMessagesSlotList({
  loading,
  items,
  onClick,
  onDelete,
}: BulkMessagesSlotListProps) {
  const listItems = useMemo(() => items, [items]);

  if (loading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }
  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }
  return (
    <div className="content-list content-list--slots">
      {listItems.map(option => (
        <div key={`${option.appointment.id}`} className="content-list__item">
          <BulkMessagesSlotListItem
            item={option}
            onClick={onClick}
            onDelete={onDelete}
          />
        </div>
      ))}
    </div>
  );
}

export { BulkMessagesSlotList };
